import React from 'react';

const PrivacyNotice: React.FC = () => {
    return (
        <div className="w-full mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Privacy Notice</h1>
            <p className="mb-4">
                This Privacy Notice describes how Micro Perceptron, Inc. ("we", "us", or "our") collects, uses, and shares information about you when you use our website and services.
            </p>
            <h2 className="text-xl font-semibold mb-2">Information We Collect</h2>
            <p className="mb-4">
                We may collect the following types of information:
            </p>
            <ul className="list-disc list-inside mb-4">
                <li>Personal Information: Information that identifies you personally, such as your name, email address, and phone number.</li>
                <li>Usage Data: Information about how you use our website and services, including your IP address, browser type, and pages visited.</li>
                <li>Cookies: Small data files stored on your device that help us improve your experience on our website.</li>
            </ul>
            <h2 className="text-xl font-semibold mb-2">How We Use Your Information</h2>
            <p className="mb-4">
                We may use the information we collect for the following purposes:
            </p>
            <ul className="list-disc list-inside mb-4">
                <li>To provide and maintain our services.</li>
                <li>To improve our website and services.</li>
                <li>To communicate with you about your account and our services.</li>
                <li>To comply with legal obligations.</li>
            </ul>
            <h2 className="text-xl font-semibold mb-2">Sharing Your Information</h2>
            <p className="mb-4">
                We do not sell or rent your personal information to third parties. We may share your information with third parties in the following circumstances:
            </p>
            <ul className="list-disc list-inside mb-4">
                <li>With service providers who assist us in providing our services.</li>
                <li>In response to a legal request or to comply with applicable laws.</li>
                <li>In connection with a merger, acquisition, or sale of all or a portion of our assets to another company.</li>
            </ul>
            <h2 className="text-xl font-semibold mb-2">Your Rights</h2>
            <p className="mb-4">
                You have the right to access, correct, or delete your personal information. You may also have the right to object to or restrict the processing of your personal information.
            </p>
            <h2 className="text-xl font-semibold mb-2">Changes to This Privacy Notice</h2>
            <p className="mb-4">
                We may update this Privacy Notice from time to time. We will notify you of any changes by posting the new Privacy Notice on our website.
            </p>
            <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
            <p className="mb-4">
                If you have any questions or concerns about this Privacy Notice, please contact us at: N/A
            </p>
            <p className="mb-4">
                By using our website and services, you consent to the collection and use of your information as described in this Privacy Notice.
            </p>
            <p className="mb-4">
                Last updated: May 2nd, 2025
            </p>
        </div>
    );
}

export default PrivacyNotice;